<template>
  <v-switch
    v-can:[togglePermission]
    :input-value="localIsEnabled"
    inset
    readonly
    @click="toggleActivation()"
  ></v-switch>
</template>

<script>
import { mapActions } from "pinia";
import { WRITE_TPS_PERMISSION } from "@/core/statics/Permissions";
import { useTrainingProgramStore } from "../../store/TrainingProgramStore";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      togglePermission: WRITE_TPS_PERMISSION,
      localIsEnabled: this.item.isEnabled,
    };
  },
  watch: {
    'item.isEnabled'(newVal) {
      this.localIsEnabled = newVal;
    }
  },
  methods: {
    ...mapActions(useTrainingProgramStore, ["toggleTrainingProgram"]),
    toggleActivation() {
      // Create the toggled data object
      const toggledData = {
        ...this.item,
        isEnabled: this.localIsEnabled == 0 ? 1 : 0
      };
      
      // Update local state immediately for UI responsiveness
      this.localIsEnabled = toggledData.isEnabled;
      
      // Send editing request - the store will update the collection
      this.toggleTrainingProgram(this.item.id, toggledData)
        .then(() => {
          // Success - store has already updated the collection
        })
        .catch((err) => {
          // Revert local state on error
          this.localIsEnabled = this.item.isEnabled;
          console.error(err);
        });
    },
  },
};
</script>
